module.exports = __webpack_public_path__ + "static/media/MobileNetSSD.f9b5ceda.png";